export const AttachSVG = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="attach">
        <path
          id="shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.84837 3.83468C8.96359 2.76663 10.4761 2.16663 12.0532 2.16663C13.6304 2.16663 15.143 2.76665 16.2582 3.83471C17.3735 4.90276 18 6.35135 18 7.8618C18 9.37222 17.3736 10.8208 16.2583 11.8889L10.2512 17.6419C9.4546 18.4048 8.3742 18.8333 7.24768 18.8333C6.12112 18.8333 5.04071 18.4047 4.24412 17.6418C3.44752 16.8789 3 15.8442 3 14.7653C3 13.6864 3.4475 12.6518 4.24409 11.8889L10.2512 6.13588C10.7292 5.6781 11.3774 5.42106 12.0533 5.42106C12.7292 5.42106 13.3775 5.67821 13.8554 6.13595C14.3334 6.59369 14.6019 7.21451 14.6019 7.86185C14.6019 8.50914 14.3335 9.1299 13.8555 9.58768L7.84837 15.3407L6.64694 14.1901L12.6541 8.43708C12.8133 8.28453 12.9028 8.07768 12.9028 7.86185C12.9028 7.64607 12.8133 7.43913 12.654 7.28655C12.4947 7.13397 12.2786 7.04825 12.0533 7.04825C11.8279 7.04825 11.6119 7.13394 11.4526 7.28648L5.44552 13.0395C4.96756 13.4972 4.69907 14.118 4.69907 14.7653C4.69907 15.4126 4.96758 16.0335 5.44554 16.4912C5.9235 16.9489 6.57175 17.2061 7.24768 17.2061C7.92365 17.2061 8.57186 16.949 9.04979 16.4913L15.0569 10.7383C15.8535 9.97541 16.3009 8.94074 16.3009 7.8618C16.3009 6.78291 15.8534 5.7482 15.0568 4.9853C14.2602 4.22241 13.1798 3.79382 12.0532 3.79382C10.9267 3.79382 9.84639 4.22238 9.04979 4.98528L4.24409 9.58768L3.04267 8.43708L7.84837 3.83468Z"
          fill="#27AE60"
        />
      </g>
    </svg>
  );
};
